import * as Style from "./StyledDepartmentCourse"
import React from "react";
import StarIcon from '@mui/icons-material/Star';
import { Link } from "react-router-dom";

const DepartmentCourse = ({ courses }) => {

    return (
        <Style.Section>
            {
                courses.map((el) => (
                    <Link to={`/about-course/${el.course_id}`} style={{ textDecoration: 'none' }} >
                        <Style.Card key={el.course_id}>
                            <Style.CardImg >
                                <Style.Img src={`${process.env.REACT_APP_BASE_URL}${el.image_path}`} />
                            </Style.CardImg>
                            <Style.CardContent>
                                <Style.TextCard >
                                    <Style.TitleCard>
                                        {el.course_name}
                                    </Style.TitleCard>
                                    <Style.DiscCard >
                                        {el.brief}
                                    </Style.DiscCard>
                                </Style.TextCard>
                                {/* <Style.SectionRate>
                                    <StarIcon sx={{ color: '#F2C94C' }} />
                                    <span style={{ fontWeight: '600', fontSize: '16px', color: '#333333' }} >
                                        {el.rate}
                                    </span>
                                    <Style.TitleDisc>({el.rate} تقييم)</Style.TitleDisc>
                                </Style.SectionRate> */}
                            </Style.CardContent>
                        </Style.Card>
                    </Link>
                ))
            }
        </Style.Section >
    )
}

export default DepartmentCourse